<template>
    <div class="page">
  
      <!-- Content Section and Navigation Together -->
      <div class="content-wrapper">
        <!-- Content Section -->
        <div class="content-section">
          <div v-for="(item, index) in content.Items" :key="index" class="content-item">
            <div class="card">  
              <div class="card-header">
                <img :src="item.image" alt="Content Image" class="image" />
              </div>
              <div class="card-body">
                <h1 class="title">{{ item.title }}</h1>
                <div v-html="formattedDescriptionNo(item.description_no_1)" class="description_no"></div>
                <div v-html="formattedDescription(item.description_1)" class="description"></div>
                <div v-html="formattedDescriptionNo(item.description_no_2)" class="description_no"></div>
                <div v-html="formattedDescription(item.description_2)" class="description"></div>
                <div v-html="formattedDescriptionNo(item.description_no_3)" class="description_no"></div>
                <div v-html="formattedDescription(item.description_3)" class="description"></div>
                <div v-html="formattedDescriptionNo(item.description_no_4)" class="description_no"></div>
                <div v-html="formattedDescription(item.description_4)" class="description"></div>
                <div v-html="formattedDescriptionNo(item.description_no_5)" class="description_no"></div>
                <div v-html="formattedDescription(item.description_5)" class="description"></div>
                <div class="card-header">
                    <img :src="item.image_1" alt="Content Image" class="image" />
                </div>
                <div v-html="formattedDescription(item.description_6)" class="description"></div>
              </div>
            </div>
          </div>
        </div>
  
        <!-- Contact Section (moved to the right) -->
        <div class="contact-container">
          <h2>Contact Information</h2>
          <div class="contact-info">
            <i class="fas fa-phone"></i>
            <p>Phone: 暂无(E-mail Only)</p>
          </div>
          <div class="contact-info">
            <i class="fas fa-envelope"></i>
            <p>Email: dankao.chen@nxtech.pub</p>
          </div>
          <!-- Add more contact info as needed -->
        </div>
      </div>
    </div>
</template>

<style src="@/assets/css/cases.css" scoped></style>

<script>
import { mapState } from "vuex";

export default {
data() {
    return {
    cn: {
        Items: [
        {
            id: 1,
            image: require("@/assets/img/PlanandCases/CultureTour/VRParkNingboScience/FairyTales.jpeg"),
            image_1: require("@/assets/img/PlanandCases/CultureTour/VRParkNingboScience/FairyGroupPhoto.jpg"),
            title: "宁波科学探索中心-童话之城",
            description_no_1:`
            <strong class="bold-text">0.引言</strong>
            `,
            description_1:`
            《童话之城》是宁波市区首个VR LBE大空间主题场馆，也是匈牙利VR Vidámpark与宁波科学探索中心首次合作打造的高科技主题场馆。

            宁波科学探索中心是集科普教育、休闲娱乐为一体的大型互动式体验科普场馆，也是国家级科普教育基地。作为宁波本地科普领域的领航者，宁波科学探索中心始终将传播科学精神、普及科学知识作为己任，致力于推动科技与文化的融合发展。
            
            在云翰虹章团队的牵线下，匈牙利VR Vidámpark团队与宁波科学探索中心成功建立稳定的长期合作关系。通过融合先进的VR/AR技术和丰富的文化元素，该场馆将为游客提供前所未有的沉浸式娱乐体验。该场馆包括各种适合不同年龄层次的VR大空间游戏、娱乐项目和设施，旨在提供一个让家庭成员可以一起放松、享受和增进感情的环境。
            
            以下为云翰虹章团队在该案例中提供的主要服务内容：
            `,
            description_no_2:`<strong class="bold-text">1. 软硬件适配和部署</strong>`,
            description_2:`  a. 为场馆装修和设备采购提供指导性意见
            b. 与内容提供方联系，制作并调整该场馆的VR LBE游戏内容
            c. 扫描场馆内部特征，绘制LBE地图并导入VR头显设备
            d. 配置该店所需的网络环境、服务器环境和VR头显环境

            `,
            description_no_3: `<strong class="bold-text">2. 管理与运维</strong>`,
            description_3:`  a. 开业高峰期，多名技术人员全程驻店，解决可能出现的技术问题
            b. 平稳运营期，技术人员将提供远程技术支持；同时，在面对难以线上解决的技术问题时，技术人员将立即前往线下解决

            `,
            description_no_4: `<strong class="bold-text">3. 员工培训</strong>`,
            description_4: `a. 培训员工使用VR头显和服务器
            b. 培训员工解决简单的技术问题

            `,
            description_no_5: ` <strong class="bold-text">案例成果</strong>`,
            description_5: `在我们的协助下，VR Park宁波科学探索中心店 “Fairy Tale” 于2024年中国国庆节顺利开业，并在黄金周内创下超1500人次的票房记录。我们期待这个项目能够提升游客们旅游体验的质量，为当地文旅注入全新的活力。云翰虹章将继续与宁波科学探索中心及VR Vidámpark携手，共同推动VR LBE技术在中国文化旅游产业的发展，为更多游客带来独特的沉浸式体验。
            `,
            description_6: `如上图为在项目内测时,（右下一、二）、VR Vidámpark代表（右下三）与宁波科学探索中心团队合影。
            `,
        },
        // Add more items as needed
        ],
    },
    en: {
        Items: [
        {
            id: 2,
            image: require("@/assets/img/PlanandCases/CultureTour/VRParkNingboScience/FairyTales.jpeg"),
            image_1: require("@/assets/img/PlanandCases/CultureTour/VRParkNingboScience/FairyGroupPhoto.jpg"),
            title: "Ningbo Science Exploration Centre: Fairy Tale",
            description_no_1:`
            <strong class="bold-text">0.Intro</strong>
            `,
            description_1:`
            "Fairy Tale" is the first VR LBE large-space theme venue in Ningbo, and the first high-tech theme venue created in cooperation between VR Vidámpark Hungary and Ningbo Science Exploration Centre.

            Ningbo Science Exploration Centre is a large-scale interactive experience science museum integrating science education, leisure and entertainment, and is also a national science education base. As a leader in the field of science popularisation in Ningbo, Ningbo Science Discovery Centre has always taken the dissemination of the spirit of science and popularisation of scientific knowledge as its own responsibility, and is committed to promoting the integration of science and technology with culture.
            
            With the help of Rosy Nebula's team, the Ningbo Science Exploration Centre has successfully established a stable and long-term cooperation relationship with VR Vidámpark. By integrating advanced VR/AR technology and rich cultural elements, the venue will provide visitors with an unprecedented immersive entertainment experience. The venue includes a variety of VR large-space games, entertainment programmes and facilities for all ages, aiming to provide an environment where family members can relax, enjoy and bond together.
            
            Below are the key services provided by the Rosy Nebula team in this case:
            `,
            description_no_2:`<strong class="bold-text">1. Hardware & software customisation and implementation</strong>`,
            description_2:`  a. Provide guidance on the renovation of the venue and equipment procurement
            b. Liaise with content providers to produce and adapt VR LBE game content for the venue
            c. Scanning the venue's internal features, creating LBE maps and importing them into the VR headset equipment
            d. Configure the network environment, server environment and VR headset environment required for the shop

            `,
            description_no_3: `<strong class="bold-text">2. Management & Operations</strong>`,
            description_3:`  a. During the peak period of opening, many technicians will be stationed in the shop to solve any technical problems that may arise.
            b. During the period of smooth operation, technicians will provide remote technical support; at the same time, in the face of technical problems that are difficult to be solved online, technicians will immediately go to the offline solution

            `,
            description_no_4: `<strong class="bold-text">3. Employee Training</strong>`,
            description_4: `  a. Train employees to use VR headsets and servers
            b. Train employees to solve simple technical problems

            `,
            description_no_5: ` <strong class="bold-text">Case Achievements</strong>`,
            description_5: `With our assistance, VR Park Ningbo Science Discovery Centre Store ‘Fairy Tale’ successfully opened on China's National Day (1/10/2024) and set a record of over 1,500 ticket sales during the Golden Week (1/10 -7/10). We expect this project can enhance the quality of tourists' experience and inject new vitality into the local culture and tourism. Rosy Nebula will continue to work with Ningbo Science Discovery Centre and VR Vidámpark to promote the development of VR LBE technology in China's cultural and tourism industry, and bring unique immersive experiences to more visitors.
            `,
            description_6: `Pictured above are representatives of Rosy Nebula (first and second from the bottom right), VR Vidámpark (third from the bottom right), and the Ningbo Science Discovery Centre team during the internal test period.
            `,
        },
        // Add more items as needed
        ],
    },
    };
},
methods: {
    formattedDescription(description) {
    // Apply additional formatting if needed
    return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
    formattedDescriptionNo(description_no) {
    // Apply additional formatting if needed
    return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
},
mixins: [],
computed: {
    ...mapState(["language"]),
    content() {
    const defaultContent = { title: "", industry_areas: [] };
    const currentLanguage = this.language === "en" ? this.en : this.cn;
    console.log("Current Language:", currentLanguage); // Debug statement
    return currentLanguage || defaultContent;
    },
},
watch: {
    language(newValue) {
    console.log("Language changed to:", newValue); // Debug statement
    this.$forceUpdate(); // Force the component to re-render when the language changes
    },
},
};
</script>
